import './App.css';

function Home() {
  return (
      <section className="contentSection contentSection--intro">
        <div className="sectionHeading">
          <span className="sectionHeading__number">01</span>
          <div>
            <p className="eyebrow">Lobo Powerlifting</p>
            <h2>Who we are</h2>
          </div>
        </div>
        <div className="introCopy">
          <span className="introCopy__mark" aria-hidden="true">LP</span>
          <p>
            Lobo Powerlifting is dedicated to giving students at the University of New Mexico the opportunity to compete in the sport of powerlifting at the collegiate level.
            Our mission is to grow the powerlifting community in New Mexico while fostering a supportive yet competitive environment for lifters of all experience levels.
            We proudly compete under the Powerlifting America (PA) federation, with members representing UNM at PA University Nationals each spring and at various local meets throughout the year.
          </p>
        </div>
      </section>
  );
}

export default Home;
